import{initHighcharts as i}from"./highcharts/highcharts.js";import{initializeSocketClient as s}from"../clients/subscriptions.js";import"./extendNative.js";i(),s();
